import { Component } from "@angular/core";
import { GlobalService } from "../services/global.service";
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
} from "@angular/router";
import { MyProgressChange } from "../interfaces/my-progress-change";
import { Authdata } from "../classes/authdata.class";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  progressChange: MyProgressChange;
  constructor(
    private globalService: GlobalService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.progressChange = this.globalService.progressChange;
  }
  isVal = this.globalService.isSlideBarShow;

  // title = 'BSRM TEMPLATE';
  copyrightYear = this.globalService.copyRightYear;
  companyDomain = this.globalService.companyDomain;
  title = "APPLICATION NAME";
  logoUrl = "/pmt/assets/images/Logo.png";
  barUrl = "/pmt/assets/images/Rod_Bar.png";

  progressColor = this.globalService.progressColor;
  progressMode = this.globalService.progressState;
  progressValue = this.globalService.progressValue;
  bufferValue = this.globalService.bufferValue;

  //isLoadingProgressShow : any;
  //this.isLoadingProgressShow = this.globalService.isLoadingProgressShow;

  // window.addEvenListener('adf', function(){

  // } );
}
